import axiosInstance from './axios'
import { AxiosResponse } from 'axios'
import { IFiltersPerson } from '../store/person/types'
import {IPaginator} from "../store/root.types";


class PersonService {
    constructor(private apiVersion: string = 'v1') {
    }

    public async getPerson(filter: IFiltersPerson, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(filter, paginator)
            return axiosInstance.get(`${this.apiVersion}/persons`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getPersonByDocument(document: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/persons/${document}`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }


    /**
     * Method to convert {@link IPaginator} object to {@link URLSearchParams}.
     * @param {IPaginator} [paginator] Paginator settings.
     * @param {IActionDocumentsRequest} [filters] Paginator settings
     * @return {URLSearchParams} Resulting object.
     */
    public buildParams(filters?: IFiltersPerson, paginator?: IPaginator): URLSearchParams {
        const params = new URLSearchParams()

        if (paginator) {

            if (paginator.page) {
                params.append('page', String(paginator.page + 1))
            }

            if (paginator.rows) {
                params.append('limit', String(paginator.rows))
            }
        }

        if (filters) {

            if (filters?.name) {
                params.append('name', String(filters.name))
            }
            if (filters?.cpf) {
                params.append('cpf', String(filters.cpf))
            }
            if (filters?.rg) {
                params.append('rg', String(filters.rg))
            }
            if (filters?.start_date) {
                params.append('start_date', String(filters.start_date))
            }
            if (filters?.end_date) {
                params.append('end_date', String(filters.end_date))
            }

        }
        return params
    }

}

const personService = new PersonService()

export default personService
